export interface ProductActivityHourWebEntity {
  productActivityId: string;
  fromTime: string;
  toTime: string;
  stopTime: string;
  serviceTime: string;
  isForAllProducts: boolean;
  service: string;
}
